import type { CollectionNames } from "~/types";

interface CreateKeyParams {
  userId: string;
  collection: CollectionNames;
  id?: string | null | undefined;
  depth?: number;
  keyAddition?: string;
  all?: boolean;
  count?: boolean;
}

/**
 * Creates a cache key based on the provided parameters
 * @param params - The parameters for creating the cache key
 * @returns The generated cache key, or null if the collection is not provided
 */
const createKey = ({
  userId,
  collection,
  id,
  depth,
  keyAddition,
  all,
  count,
}: CreateKeyParams): string => {
  if (!collection) return "";

  let key = `${userId}-${collection}`;

  if (id) {
    key = `${key}-${id}`;
  }

  if (all) {
    key = `${key}-all`;
  }

  if (count) {
    key = `${key}-count`;
  }

  if (keyAddition) {
    key = `${key}-${keyAddition}`;
  }

  if (!depth) return key;

  return `${key}-depth-${depth}`;
};

export default createKey;
